/**
 * EmailVerificationPage component
 * Shown after registration to prompt users to verify their email
 */
const EmailVerificationPage: React.FC = () => {
  return (
    <div className="email-verification-container">
      <div className="email-verification-content">
        <div className="email-verification-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3 7L12 13L21 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <h2 className="email-verification-title">Check Your Email</h2>
        <p className="email-verification-text">
          We've sent a verification email to your inbox. Please click the link in the email to verify your account before logging in.
        </p>
        <p className="email-verification-text">
          Didn't receive the email? Check your spam folder or contact support for assistance.
        </p>
      </div>
    </div>
  );
};

export default EmailVerificationPage;
